import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { NotificationSeverity } from '../../model/enums/notification-severity';
import { NotificationMessage } from '../../model/interfaces/notification-message';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy
{
    @Output() public navigate = new EventEmitter();

    @Output() public scroll = new EventEmitter();

    @Input() public typeFilter: string;

    @Input() public redirectViewOnCloseNotification?: string;

    public title = '';
    public message: string;
    public severity: NotificationSeverity;
    public notificationMessage: NotificationMessage = null;
    public confirmation: { onOk: () => void, onCancel: () => void, okText?: string, cancelText?: string };

    private notificationService: NotificationService;
    private notificationServiceSubscription: Subscription;

    constructor(notificationService: NotificationService)
    {
        this.notificationService = notificationService;
    }

    public ngOnInit(): void
    {
        // TODO: Comment on this.
        this.notificationServiceSubscription = this.notificationService.getNotificationMessageObservable().subscribe((data: NotificationMessage) =>
        {
            if (data)
            {
                if (this.hasDataAfterFilter(data) === false)
                {
                    return;
                }
                else
                {
                    this.notificationMessage = data;
                    this.title = data.title;
                    this.message = data.message;

                    if (data.severity)
                    {
                        this.severity = data.severity;
                    } else
                    {
                        this.severity = NotificationSeverity.info;
                    }

                    if (data.confirmation != null)
                    {
                        this.confirmation = { ...data.confirmation };
                        this.confirmation.cancelText = this.confirmation.cancelText || 'Cancel';
                        this.confirmation.okText = this.confirmation.okText || 'Ok';
                    }
                }
                this.scrollToNotificationMessage(event);
            }
            else
            {
                this.notificationMessage = null;
                this.title = '';
                this.message = '';
                this.confirmation = null;
            }
        });
    }

    public onOkClick(): void
    {
        this.confirmation.onOk();
        this.close();
    }

    public onCancelClick(): void
    {
        this.confirmation.onCancel();
        this.close();
    }


    private hasDataAfterFilter(data: NotificationMessage): boolean
    {
        if (!this.typeFilter || !data.filterValue)
        {
            return true;
        }
        if (this.typeFilter != data.filterValue)
        {
            return false;
        }
        else
        {
            return true;
        }
    }

    public showView(view: string): void
    {
        this.navigate.emit(view);
    }

    public scrollToNotificationMessage(ev: any): void
    {
        this.scroll.emit();
    }

    public close(): void
    {
        this.notificationMessage = null;
        if (this.redirectViewOnCloseNotification)
        {
            this.showView(this.redirectViewOnCloseNotification);
        }
    }

    public ngOnDestroy(): void
    {
        this.notificationService.notify(null);
        this.notificationServiceSubscription.unsubscribe();
    }
}
